import { gql } from "@apollo/client";

export const GET_SOCCER_GAME_TIMELINE = gql`
  query GetSoccerGameTimeline($gameId: Int!, $teamId: Int!) {
    getTeamRosterForLineup(gameId: $gameId, teamId: $teamId) {
      player {
        id
        fullName
      }
      position {
        key
        name
      }
      jerseyNumber
    }
    soccerPlayerScoresByGame(gameId: $gameId) {
      id
      minute
      period
      actionType
      notes
      jerseyNumber
      player {
        id
        fullName
      }
      relatedPlayer {
        id
        fullName
      }
      team{
          id
          name
      }
    }
  }
`;
